/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */
import { LocaleObject } from 'yup/lib/locale';

import { stringFormatParams } from '../../../utils/stringFormat';
import { ELocaleKeys } from '../../internationalization/intConstants';
import { ICorporateFormTranslation } from '../../internationalization/types/corporate';
import EFormValidation from './formValidation';

export const getFormLocale = (
    translation: ICorporateFormTranslation['validation'],
): LocaleObject => ({
    array: {
        min: translation[EFormValidation.fieldRequired],
    },
    mixed: {
        notType: translation[EFormValidation.fieldRequired],
        required: translation[EFormValidation.fieldRequired],
    },
    number: {
        min: ({ min }) => stringFormatParams(translation[EFormValidation.fieldNumberMin], {
            [ELocaleKeys.number]: min,
        }),
        max: ({ max }) => stringFormatParams(translation[EFormValidation.fieldNumberMax], {
            [ELocaleKeys.number]: max,
        }),
    },
    string: {
        email: translation[EFormValidation.fieldEmail],
        matches: translation[EFormValidation.fieldNotType],
        min: translation[EFormValidation.fieldRequired],
        length: translation[EFormValidation.fieldNotType],
    },
});

